import React from 'react';

import styles from './userProfileBannerStyles';

import Banner from 'buyside/components/presentation/Banner/banner';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import XMarkIcon from 'buyside/svgs/x_mark.svg';

import { COMMUNITY, HIRING_MANAGER } from 'buyside/util/userProfileConstants';

const FundProfileBanner = ({ viewAsMode, viewingAs, toggleViewAsMode, viewAs }) => {
  if (viewAsMode) {
    return (
      <Banner>
        <span>Viewing this profile as a:</span>
        <select
          value={viewingAs}
          className={styles.viewAsSelect}
          onChange={e => viewAs(e.target.value)}
          data-testid="user-profile-viewas-select"
        >
          <option value={COMMUNITY}>General community member</option>
          <option value={HIRING_MANAGER}>Hiring manager</option>
        </select>
        <Button
          text="RETURN TO EDITING MODE"
          onClick={toggleViewAsMode}
          type={BUTTON_TYPES.LINK}
          icon={XMarkIcon}
          iconStyle={styles.returnIcon}
        />
      </Banner>
    );
  } else {
    return <div />;
  }
};

export default FundProfileBanner;
